/* House picks: proper line breaks (RULE 10-07/10-13). sections/house-picks.liquid.
   Small words stay with the next word, set phrases stay whole, and the last two
   words of every block stay together, so no line ends on "the" and no word sits
   alone. Runs on the copy from the theme editor, so edits keep the rule. */
(function () {
  var NB = ' ';
  var SMALL = 'a|an|the|to|of|in|on|for|your|our|its|it’s|and|or|is|are|from|with|at|by|we|we’d|you|you’re|so|but|not|no|one|every|each|who|it|than';
  var PHRASES = ['real people', 'do it again', 'best for', 'next year', 'your drawer', 'the explanation', 'ahead of time',
    'the next one', 'your audience', 'on the spot', 'staff picks', 'house pick', 'house picks', 'living room', 'next week',
    'didn’t get', 'out loud', 'real light', 'put it away', 'still be doing'];
  // Headings: a short sentence (up to 4 words) never breaks inside itself,
  // so "You have a drawer. Maybe two. Okay, three." breaks only between sentences.
  function keepShort(t) {
    return t.replace(/[^.!?]+[.!?]*/g, function (sn) {
      var words = sn.trim().split(/\s+/);
      return words.length && words.length <= 4 ? sn.replace(/(\S) +(?=\S)/g, '$1' + NB) : sn;
    });
  }
  var small = new RegExp('(^|[\\s(“])(' + SMALL + ') +', 'gi');
  function tidy(t) {
    PHRASES.forEach(function (p) { t = t.split(p).join(p.replace(/ /g, NB)); });
    var prev;
    do { prev = t; t = t.replace(small, '$1$2' + NB); } while (t !== prev);
    return t;
  }
  function run(root) {
    root.querySelectorAll('h1, h2, p, b, span, li').forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, last = null;
      while ((n = w.nextNode())) {
        if (n.parentNode !== el) continue;
        n.data = tidy(n.data);
        if (el.closest('h1, h2')) n.data = keepShort(n.data);
        if (/\S/.test(n.data)) last = n;
      }
      if (last) last.data = last.data.replace(/(\S) +(\S+\s*)$/, '$1' + NB + '$2');
    });
  }
  document.querySelectorAll('[data-hp]').forEach(run);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-hp]');
    if (r) run(r);
  });
})();
